import { Reducer } from "redux";
import { getDealSuccess } from "src/store/actions/deal";
import { pollingSuccess } from "src/store/actions/poller";

type HandledActions = ReturnType<typeof pollingSuccess> | ReturnType<typeof getDealSuccess>;

export type HasSignatures = boolean;

const defaultState = false;

const hasSignatures: Reducer<HasSignatures, HandledActions> = (state = defaultState, action) => {
    switch (action.type) {
        case pollingSuccess.type:
        case getDealSuccess.type:
            return (action.payload.deal.signatures?.length ?? 0) > 0;
        default:
            return state;
    }
};

export default hasSignatures;
